import React from "react";
import {IconButton} from "@material-ui/core";
import UserButton from "./UserButtonContainer";

export default () => {
    const button = (props) => <IconButton edge="start" color="inherit" {...props} />;
    return <UserButton button={button}/>;
}
